// extracted by mini-css-extract-plugin
export var optionGrid = "_5n-7";
export var optionList = "_5n-6";
export var questionsBlock = "_5n-9";
export var spacer = "_5n-5";
export var stepCenteredContent = "_5n-3";
export var stepInner = "_5n-0";
export var stepInnerFullWidth = "_5n-1";
export var stepInnerLockScroll = "_5n-2";
export var stepTransitionFrame = "_5n-4";
export var welcomeBlock = "_5n-8";